import React, { useEffect, useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";

/**
 * Displays a compact banner when the browser goes offline and hides
 * automatically when the connection returns.
 */
export default function OnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed top-2 left-1/2 z-[70] -translate-x-1/2 rounded-full border border-amber-300 bg-amber-50 px-3 py-1.5 shadow-md"
      data-testid="offline-banner"
    >
      <div className="flex items-center gap-2 text-xs font-semibold text-amber-900">
        <WifiOff className="h-3.5 w-3.5" />
        Offline · le timbrature verranno sincronizzate al ritorno online
        <RefreshCw className="h-3 w-3 animate-spin text-amber-700" />
      </div>
    </div>
  );
}
